import React from 'react';
const cssBaselineStyles = "c1bx1u42";
export const CssBaseline = () => {
  return <div className={cssBaselineStyles} />;
};

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");